export default __webpack_public_path__ + "static/about-1-022652bd4012283d10b04bbe3e5d9b0a.webp";